<div id="mail-change" class="flex flex-col" fusePerfectScrollbar>
  <div id="mail-change-form-wrapper" class="flex flex-col items-center justify-center">
    <div id="mail-change-form" *fuseIfOnDom [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
      <div class="logo">
        <mat-icon class="s-96">check_circle</mat-icon>
      </div>

      <div i18n class="title">Email изменен</div>

      <div class="subtitle">
        <p>
          <span i18n>Ваш аккаунт был успешно привязан к новому Email</span>
        </p>
      </div>

      <div class="message">
        <a i18n *ngIf="auth && userOrign" class="link" href="{{ userOrign }}" target="_self"
          >Вернуться на стартовую страницу</a
        >
        <a i18n *ngIf="!auth && userOrign" class="link" href="{{ userOrign }}" target="_self"
          >Вернуться на страницу авторизации</a
        >
      </div>
    </div>
  </div>
</div>
